<ng-container [formGroup]="formGroup" >


  <mat-selection-list #projectSelection id="projectSelect">
    @for (assignedProject of assignedProjects; track assignedProject) {
      <mat-list-option
        [selected]="assignedProject.assigned"
        (click)="toggleProject(assignedProject)"
        >
        <div mat-line>{{assignedProject.project.projectName}}</div>
        <div mat-line> {{helpersService.formatDate(assignedProject.project.startDateTime)}} - {{helpersService.formatDate(assignedProject.project.endDateTime)}} </div>
      </mat-list-option>
    }
  </mat-selection-list>

  <p>
    Projects selected: {{projectSelection.selectedOptions.selected.length}}
  </p>



</ng-container>
